import React from 'react';
import { useIntl } from 'react-intl';

interface ExtraMode {
    key: string;
    active: boolean;
    onClick: () => void;
    icon: React.ReactNode;
    tooltip?: string;
}

interface MikaViewToggleProps {
    mode: 'table' | 'card';
    onChange: (mode: 'table' | 'card') => void;
    extraModes?: ExtraMode[];
}

const btnStyle = (active: boolean): React.CSSProperties => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    border: 'none',
    background: active ? '#1e3a5f' : '#f1f5f9',
    color: active ? '#fff' : '#64748b',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
});

const MikaViewToggle: React.FC<MikaViewToggleProps> = ({ mode, onChange, extraModes }) => {
    const intl = useIntl();
    const fm = (id: string, defaultMessage: string) => intl.formatMessage({ id, defaultMessage });

    const hasExtra = extraModes && extraModes.length > 0;
    const anyExtraActive = hasExtra && extraModes.some(m => m.active);

    return (
        <div style={{ display: 'inline-flex', borderRadius: 6, overflow: 'hidden', border: '1px solid #d0dbe8' }}>
            <button
                style={{ ...btnStyle(mode === 'table' && !anyExtraActive), borderRadius: '5px 0 0 5px' }}
                onClick={() => onChange('table')}
                title={fm('common.view.table', 'Table')}
                type="button"
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M3 3h18v18H3zM3 9h18M3 15h18M9 3v18M15 3v18" />
                </svg>
            </button>
            <button
                style={{ ...btnStyle(mode === 'card' && !anyExtraActive), borderRadius: hasExtra ? '0' : '0 5px 5px 0' }}
                onClick={() => onChange('card')}
                title={fm('common.view.cards', 'Cards')}
                type="button"
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="3" width="7" height="7" rx="1" />
                    <rect x="14" y="3" width="7" height="7" rx="1" />
                    <rect x="3" y="14" width="7" height="7" rx="1" />
                    <rect x="14" y="14" width="7" height="7" rx="1" />
                </svg>
            </button>
            {hasExtra && extraModes.map((em, idx) => (
                <button
                    key={em.key}
                    style={{
                        ...btnStyle(em.active),
                        borderRadius: idx === extraModes.length - 1 ? '0 5px 5px 0' : '0',
                    }}
                    onClick={em.onClick}
                    title={em.tooltip || em.key}
                    type="button"
                >
                    {em.icon}
                </button>
            ))}
        </div>
    );
};

export default MikaViewToggle;
